module.exports = __webpack_public_path__ + "img/手机.503b2708.png";